/* Puddle & Paw — interacciones propias */
(function () {
  if (window.__ppInit) return;
  window.__ppInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia('(hover: none)').matches;
  var observer = null;

  function once(el, key) {
    key = key + 'Done';
    if (!el || el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Reveals ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.pp-reveal, [data-pp-observe]');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('pp-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('pp-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('pp-visible')) observer.observe(el); });
  }

  /* ---------- Vídeos: quitar el que no toca (ordenador/móvil) ---------- */
  function initVideos(root) {
    var mob = window.matchMedia('(max-width: 749px)').matches;
    (root || document).querySelectorAll('[data-pp-pair]').forEach(function (wrap) {
      if (!once(wrap, 'ppPair')) return;
      var drop = wrap.querySelector(mob ? '.pp-only-desk' : '.pp-only-mob');
      if (drop && wrap.querySelector(mob ? '.pp-only-mob' : '.pp-only-desk')) drop.remove();
    });
    (root || document).querySelectorAll('.pp-media video').forEach(function (v) {
      v.muted = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      if (reduce) { v.removeAttribute('autoplay'); v.pause && v.pause(); return; }
      var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---------- Lluvia (canvas) ---------- */
  function initRain(root) {
    (root || document).querySelectorAll('canvas[data-pp-rain]').forEach(function (cv) {
      if (!once(cv, 'ppRain') || reduce) return;
      var ctx = cv.getContext('2d');
      var density = parseInt(cv.dataset.ppRain, 10) || 60;
      var drops = [], w, h, running = false, raf;
      function size() {
        var r = cv.getBoundingClientRect();
        w = cv.width = r.width * (window.devicePixelRatio > 1 ? 1.5 : 1);
        h = cv.height = r.height * (window.devicePixelRatio > 1 ? 1.5 : 1);
      }
      function make() {
        drops = [];
        var n = window.innerWidth < 750 ? Math.round(density / 2) : density;
        for (var i = 0; i < n; i++) drops.push({ x: Math.random() * w, y: Math.random() * h, l: 10 + Math.random() * 18, s: 6 + Math.random() * 8, o: 0.15 + Math.random() * 0.35 });
      }
      function tick() {
        ctx.clearRect(0, 0, w, h);
        ctx.lineCap = 'round';
        for (var i = 0; i < drops.length; i++) {
          var d = drops[i];
          ctx.strokeStyle = 'rgba(255,255,255,' + d.o + ')';
          ctx.lineWidth = 1.2;
          ctx.beginPath(); ctx.moveTo(d.x, d.y); ctx.lineTo(d.x - d.l * 0.18, d.y + d.l); ctx.stroke();
          d.y += d.s; d.x -= d.s * 0.18;
          if (d.y > h) { d.y = -d.l; d.x = Math.random() * w * 1.1; }
        }
        if (running) raf = requestAnimationFrame(tick);
      }
      size(); make();
      window.addEventListener('resize', function () { size(); make(); });
      new IntersectionObserver(function (e) {
        running = e[0].isIntersecting;
        if (running) { cancelAnimationFrame(raf); tick(); }
      }).observe(cv);
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnet(root) {
    if (isTouch || reduce) return;
    (root || document).querySelectorAll('.pp-magnet').forEach(function (b) {
      if (!once(b, 'ppMag')) return;
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + x * 8 + 'px,' + y * 6 + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------- Hotspots ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-pp-hot]').forEach(function (wrap) {
      if (!once(wrap, 'ppHot')) return;
      var dots = wrap.querySelectorAll('.pp-dot');
      var items = wrap.querySelectorAll('.pp-hot__item');
      function set(i) {
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        items.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { set(i); if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
        d.addEventListener('mouseenter', function () { set(i); });
      });
      items.forEach(function (d, i) {
        d.addEventListener('mouseenter', function () { set(i); });
        d.addEventListener('click', function () { set(i); });
      });
      set(0);
    });
  }

  /* ---------- Escenarios ---------- */
  function initScenes(root) {
    (root || document).querySelectorAll('[data-pp-scenes]').forEach(function (wrap) {
      if (!once(wrap, 'ppScn')) return;
      var tabs = wrap.querySelectorAll('.pp-scn__tab');
      var panels = wrap.querySelectorAll('.pp-scn__panel');
      var auto = parseInt(wrap.dataset.ppScenes, 10) || 0;
      var cur = 0, timer;
      function set(i) {
        cur = i;
        tabs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-selected', k === i); });
        panels.forEach(function (p, k) {
          p.classList.toggle('is-active', k === i);
          var v = p.querySelector('video');
          if (v) { if (k === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause(); }
        });
      }
      function start() { if (auto > 0 && !reduce) { clearInterval(timer); timer = setInterval(function () { set((cur + 1) % panels.length); }, auto * 1000); } }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { set(i); clearInterval(timer); }); });
      wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
      set(0); start();
    });
  }

  /* ---------- Buscador de talla ---------- */
  function initSizeFinder(root) {
    (root || document).querySelectorAll('[data-pp-size]').forEach(function (wrap) {
      if (!once(wrap, 'ppSize')) return;
      var data;
      try { data = JSON.parse(wrap.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
      var sizes = data.sizes || [];
      var ease = data.ease || 2;
      var unit = data.unit || 'in';
      var tabs = wrap.querySelectorAll('[data-pp-mode]');
      var modes = wrap.querySelectorAll('.pp-size__mode');
      var result = wrap.querySelector('.pp-result');
      var rows = wrap.querySelectorAll('.pp-table tbody tr');
      var chest = wrap.querySelector('[name="pp-chest"]');
      var back = wrap.querySelector('[name="pp-back"]');
      var unitBtns = wrap.querySelectorAll('[data-pp-unit]');

      function fmt(cm) { return unit === 'in' ? (Math.round(cm / 2.54 * 10) / 10) + '"' : Math.round(cm * 10) / 10 + ' cm'; }
      function paintTable() {
        wrap.querySelectorAll('[data-cm]').forEach(function (el) { el.textContent = fmt(parseFloat(el.dataset.cm)); });
        unitBtns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.ppUnit === unit); });
        wrap.querySelectorAll('[data-pp-unit-label]').forEach(function (l) { l.textContent = unit === 'in' ? 'inches' : 'cm'; });
      }
      function show(idx, title, sub) {
        rows.forEach(function (r, k) { r.classList.toggle('is-hit', k === idx); });
        if (!result) return;
        if (idx < 0) { result.hidden = true; return; }
        result.hidden = false;
        result.querySelector('.pp-result__size').textContent = sizes[idx].label;
        result.querySelector('.pp-result__t').textContent = title;
        result.querySelector('.pp-result__s').textContent = sub;
        var btn = result.querySelector('[data-pp-pick]');
        if (btn) btn.dataset.ppPick = sizes[idx].label;
        result.style.animation = 'none'; void result.offsetWidth; result.style.animation = '';
      }
      function calc() {
        var c = parseFloat(chest && chest.value);
        var b = parseFloat(back && back.value);
        if (!c || c <= 0) { show(-1); return; }
        var toCm = unit === 'in' ? 2.54 : 1;
        var ccm = c * toCm, bcm = b ? b * toCm : 0;
        var idx = -1;
        for (var i = 0; i < sizes.length; i++) { if (sizes[i].chest >= ccm + ease) { idx = i; break; } }
        if (idx === -1) {
          rows.forEach(function (r) { r.classList.remove('is-hit'); });
          if (result) {
            result.hidden = false;
            result.querySelector('.pp-result__size').textContent = '!';
            result.querySelector('.pp-result__t').textContent = data.tooBig;
            result.querySelector('.pp-result__s').textContent = data.tooBigSub;
          }
          return;
        }
        var sub = data.fitSub.replace('{chest}', fmt(sizes[idx].chest)).replace('{back}', fmt(sizes[idx].back));
        if (bcm && bcm > sizes[idx].back + 3) sub += ' ' + data.longBack;
        show(idx, data.fitTitle.replace('{size}', sizes[idx].label), sub);
      }
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          modes.forEach(function (m) { m.hidden = m.dataset.mode !== t.dataset.ppMode; });
          show(-1);
        });
      });
      wrap.querySelectorAll('.pp-breed').forEach(function (b) {
        b.addEventListener('click', function () {
          wrap.querySelectorAll('.pp-breed').forEach(function (x) { x.classList.toggle('is-active', x === b); });
          var lbl = b.dataset.size;
          var idx = -1;
          sizes.forEach(function (s, k) { if (s.label.toLowerCase() === lbl.toLowerCase()) idx = k; });
          if (idx > -1) show(idx, data.breedTitle.replace('{breed}', b.textContent.trim()).replace('{size}', sizes[idx].label), data.breedSub);
        });
      });
      unitBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.dataset.ppUnit === unit) return;
          var f = b.dataset.ppUnit === 'cm' ? 2.54 : 1 / 2.54;
          [chest, back].forEach(function (inp) { if (inp && inp.value) inp.value = Math.round(parseFloat(inp.value) * f * 10) / 10; });
          unit = b.dataset.ppUnit; paintTable(); calc();
        });
      });
      [chest, back].forEach(function (inp) { if (inp) inp.addEventListener('input', calc); });
      wrap.addEventListener('click', function (e) {
        var pick = e.target.closest('[data-pp-pick]');
        if (!pick) return;
        var lbl = pick.dataset.ppPick;
        var target = document.querySelector('.pp-sizebtn[data-value="' + lbl + '"]');
        if (target) {
          e.preventDefault();
          target.click();
          var modal = wrap.closest('.pp-modal');
          if (modal) modal.classList.remove('is-open');
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
      paintTable();
    });
  }

  /* ---------- Galería arrastrable ---------- */
  function initDrag(root) {
    if (isTouch) return;
    (root || document).querySelectorAll('[data-pp-drag]').forEach(function (el) {
      if (!once(el, 'ppDrag')) return;
      var down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('mousedown', function (e) { down = true; moved = false; sx = e.pageX; sl = el.scrollLeft; el.classList.add('is-drag'); });
      window.addEventListener('mouseup', function () { if (down) { down = false; el.classList.remove('is-drag'); } });
      el.addEventListener('mousemove', function (e) { if (!down) return; e.preventDefault(); var dx = e.pageX - sx; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = sl - dx * 1.2; });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Frase que se ilumina ---------- */
  function initGlow(root) {
    (root || document).querySelectorAll('[data-pp-glow]').forEach(function (el) {
      if (!once(el, 'ppGlow')) return;
      var words = el.querySelectorAll('.pp-w');
      if (reduce) { words.forEach(function (w) { w.classList.add('on'); }); return; }
      function upd() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * words.length);
        words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
      }
      window.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* ---------- Parallax suave ---------- */
  function initParallax(root) {
    if (reduce) return;
    var els = (root || document).querySelectorAll('[data-pp-parallax]');
    if (!els.length) return;
    function upd() {
      els.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        var k = parseFloat(el.dataset.ppParallax) || 0.12;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  /* ---------- Modales ---------- */
  function initModals() {
    if (window.__ppModals) return; window.__ppModals = true;
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-pp-open]');
      if (open) {
        var m = document.getElementById(open.dataset.ppOpen);
        if (m) { e.preventDefault(); m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      if (e.target.closest('[data-pp-close]') || e.target.classList.contains('pp-modal')) {
        var mm = e.target.closest('.pp-modal');
        if (mm) { mm.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.pp-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; });
    });
  }

  /* ---------- Producto ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-pp-product]').forEach(function (wrap) {
      if (!once(wrap, 'ppProd')) return;
      var json = wrap.querySelector('script[data-pp-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var money = wrap.dataset.moneyFormat || '${{amount}}';
      var idInput = wrap.querySelector('form[action*="/cart/add"] input[name="id"]');
      var atc = wrap.querySelector('.pp-atc');
      var atcText = atc && atc.querySelector('span');
      var priceNow = wrap.querySelector('.pp-price__now');
      var priceWas = wrap.querySelector('.pp-price__was');
      var priceSave = wrap.querySelector('.pp-price__save');
      var fitBox = wrap.querySelector('[data-pp-fit]');
      var sticky = document.querySelector('[data-pp-sticky]');
      var groups = wrap.querySelectorAll('[data-pp-option]');
      var slides = wrap.querySelectorAll('.pp-gal__slide');
      var thumbs = wrap.querySelectorAll('.pp-gal__thumb');
      var cur = 0;

      function formatMoney(cents) {
        var v = (cents / 100).toFixed(2);
        var parts = v.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return money.replace(/\{\{\s*amount\s*\}\}/, parts.join('.')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts.join(','));
      }
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        if (thumbs[cur]) thumbs[cur].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = wrap.querySelector('.pp-gal__nav--prev'), next = wrap.querySelector('.pp-gal__nav--next');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      var main = wrap.querySelector('.pp-gal__main');
      if (main) {
        var tx = 0;
        main.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); });
      }

      function selected() {
        var vals = [];
        groups.forEach(function (g) { vals[parseInt(g.dataset.ppOption, 10)] = g.dataset.selected; });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < vals.length; k++) { if (vals[k] != null && v.options[k] !== vals[k]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability() {
        groups.forEach(function (g) {
          var pos = parseInt(g.dataset.ppOption, 10);
          g.querySelectorAll('[data-value]').forEach(function (b) {
            var vals = selected(); vals[pos] = b.dataset.value;
            var v = findVariant(vals);
            b.classList.toggle('is-soldout', !v || !v.available);
          });
        });
      }
      function update() {
        var v = findVariant(selected());
        groups.forEach(function (g) { var em = g.querySelector('legend em'); if (em) em.textContent = g.dataset.selected || ''; });
        markAvailability();
        if (!v) {
          if (atc) { atc.setAttribute('disabled', 'disabled'); if (atcText) atcText.textContent = atc.dataset.unavailable; }
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (priceNow) priceNow.textContent = formatMoney(v.price);
        if (priceWas) { priceWas.hidden = !(v.compare_at_price > v.price); priceWas.textContent = v.compare_at_price ? formatMoney(v.compare_at_price) : ''; }
        var onSale = v.compare_at_price > v.price;
        var saveTxt = onSale ? formatMoney(v.compare_at_price - v.price).replace(/[.,]00(?=\D*$)/, '') : '';
        var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        if (priceSave) { priceSave.hidden = !onSale; if (onSale) priceSave.textContent = priceSave.dataset.tpl.replace('[amount]', saveTxt).replace('[percent]', pct); }
        wrap.querySelectorAll('[data-pp-sale]').forEach(function (el) { el.hidden = !onSale; if (onSale) el.textContent = el.dataset.tpl.replace('[amount]', saveTxt).replace('[percent]', pct); });
        if (atc) {
          if (v.available) { atc.removeAttribute('disabled'); atc.removeAttribute('aria-disabled'); if (atcText) atcText.textContent = atc.dataset.add; }
          else { atc.setAttribute('disabled', 'disabled'); if (atcText) atcText.textContent = atc.dataset.soldout; }
        }
        if (v.featured_media_id) {
          slides.forEach(function (s, k) { if (s.dataset.mediaId == v.featured_media_id) go(k); });
        }
        if (fitBox) {
          var sizeGroup = wrap.querySelector('[data-pp-option][data-is-size]');
          if (sizeGroup) {
            var b = sizeGroup.querySelector('[data-value="' + (sizeGroup.dataset.selected || '').replace(/"/g, '') + '"]');
            var txt = b && b.dataset.fit;
            fitBox.hidden = !txt;
            if (txt) fitBox.querySelector('span').textContent = txt;
          }
        }
        if (sticky) {
          var sp = sticky.querySelector('[data-pp-sticky-variant]');
          if (sp) { sp.textContent = v.title + ' · ' + formatMoney(v.price) + ' '; if (onSale) { var sw = document.createElement('s'); sw.textContent = formatMoney(v.compare_at_price); sp.appendChild(sw); } }
        }
        try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); } catch (e) {}
      }
      groups.forEach(function (g) {
        g.querySelectorAll('[data-value]').forEach(function (b) {
          b.addEventListener('click', function () {
            g.dataset.selected = b.dataset.value;
            g.querySelectorAll('[data-value]').forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
            update();
          });
        });
      });
      var qty = wrap.querySelector('.pp-qty input');
      wrap.querySelectorAll('.pp-qty button').forEach(function (b) {
        b.addEventListener('click', function () { var n = parseInt(qty.value, 10) || 1; qty.value = Math.max(1, n + parseInt(b.dataset.step, 10)); });
      });
      update();

      if (sticky && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          var r = e[0].boundingClientRect;
          sticky.classList.toggle('is-on', !e[0].isIntersecting && r.top < 0);
        }).observe(atc);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { atc.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { atc.click(); }, 450); });
      }
    });
  }

  /* ---------- Fecha estimada de entrega ---------- */
  function initEta(root) {
    (root || document).querySelectorAll('[data-pp-eta]').forEach(function (el) {
      if (!once(el, 'ppEta')) return;
      var parts = el.dataset.ppEta.split('-');
      var a = parseInt(parts[0], 10) || 7, b = parseInt(parts[1], 10) || 12;
      function addBiz(n) { var d = new Date(); var c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; }
      var o = { month: 'short', day: 'numeric' };
      var s = el.querySelector('[data-pp-eta-dates]');
      if (s) s.textContent = addBiz(a).toLocaleDateString('en-US', o) + ' – ' + addBiz(b).toLocaleDateString('en-US', o);
    });
  }

  function initAll(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root); initVideos(root); initRain(root); initMagnet(root); initHotspots(root);
    initScenes(root); initSizeFinder(root); initDrag(root); initGlow(root); initParallax(root);
    initModals(); initProduct(root); initEta(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
